import React from 'react';
import { Layout, Menu, Typography } from 'antd';
import DesktopOutlined from '@ant-design/icons/DesktopOutlined';
import { useHistory } from 'react-router-dom';
import routes from 'configs/routes';
import constants from 'data/constants';
import useWindowDimensions from 'data/useWindowDimensions';

const Sidebar = props => {
  const { Text } = Typography;
  const { Sider } = Layout;
  const { width } = useWindowDimensions();
  const history = useHistory();

  return (
    <Sider
      collapsible={false}
      collapsed={width < constants.TABLET_WIDTH ? true : false}
      style={{
        overflow: 'auto',
        height: '100vh',
        position: 'fixed',
        left: 0
      }}>
      <div className="logo-container">
        <Text style={{ color: '#fff', fontWeight: 'bold', fontSize: 22 }}>Content Library</Text>
      </div>
      <Menu theme="dark" defaultSelectedKeys={[props.selectedKey]} mode="inline">
        <Menu.Item
          key="home"
          onClick={() => {
            history.push(routes.home);
          }}>
          <DesktopOutlined />
          <span>Home</span>
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
